const PROFILE_STORAGE_KEY = 'siege-tank-player-profile';

export interface PlayerProfile {
  installId: string;
  nickname: string;
}

export function loadPlayerProfile(): PlayerProfile {
  try {
    const raw = localStorage.getItem(PROFILE_STORAGE_KEY);
    if (raw) {
      const parsed = JSON.parse(raw) as Partial<PlayerProfile>;
      if (parsed.installId && parsed.nickname) return { installId: parsed.installId, nickname: sanitizeNickname(parsed.nickname) };
      if (parsed.installId) return { installId: parsed.installId, nickname: defaultNickname(parsed.installId) };
    }
  } catch {
    // ignore
  }
  const installId = globalThis.crypto?.randomUUID?.() ?? `local-${Math.random().toString(36).slice(2, 10)}`;
  const profile = { installId, nickname: defaultNickname(installId) };
  savePlayerProfile(profile);
  return profile;
}

export function savePlayerProfile(profile: PlayerProfile): PlayerProfile {
  const normalized = {
    installId: profile.installId,
    nickname: sanitizeNickname(profile.nickname),
  };
  try {
    localStorage.setItem(PROFILE_STORAGE_KEY, JSON.stringify(normalized));
  } catch {
    // ignore
  }
  return normalized;
}

export function sanitizeNickname(value: string): string {
  const trimmed = value.trim().replace(/\s+/g, ' ').slice(0, 20);
  return trimmed || 'Commander';
}

function defaultNickname(installId: string): string {
  return `Commander-${installId.replace(/-/g, '').slice(0, 4).toUpperCase()}`;
}
